import { DataTable } from "./DataTable";
import { Button, message } from "antd";
import { YhBox } from "@/components/YhBox";
import { threeInspectionSchedulingModel } from "../schedulingModel";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";

export const DataBox = () => {
    const { setAddCarVisible, onDelete, selectedRowKeys } = threeInspectionSchedulingModel();

    const action = <>
        {/* disabled={userType!=='管理员'} */}
        <Button style={{ marginBottom: '5px' }} shape="round" type="link" onClick={() => setAddCarVisible(true)}><PlusOutlined />添加排班</Button>
        <Button style={{ marginBottom: '5px' }} shape="round" type="link" onClick={() => {
            if (!selectedRowKeys?.length) {
                return message.warning('请选择排班进行删除功能！')
            } else {
                onDelete(selectedRowKeys)
            }
        }}><DeleteOutlined />一键删除</Button>
        {/* <Button shape="round" type="primary" onClick={sendNotifications}><ShakeOutlined />发送通知</Button> */}
    </>;


    return (
        <div>
            <YhBox title="" action={action} style={{ height: 'calc(100vh - 185px)' }}>
                <DataTable />
            </YhBox>
        </div>
    )
}